/** Admin workflow preview runs under /admin/flow/:id/preview (no asset access key). */
export function isAdminWorkflowPreviewPath(pathname) {
  return /^\/admin\/flow\/[^/]+\/preview(?:\/|$)/.test(pathname || '');
}
